import React from "react";
import { connect } from "react-redux";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection,
  ColumnChooser,
  ColumnFixing,
  StateStoring,
  HeaderFilter
} from "devextreme-react/data-grid";
import { columns } from "./utils";
import CachedIcon from "@material-ui/icons/Cached";
import { withStyles } from "@material-ui/core/styles";
import SquareButton from "../../../../../ui/SquareButton";
import AddButton from "../../../../../ui/AddButton";
import SearchField from "../../../../../ui/SearchField";
import OutsideClickHandler from "react-outside-click-handler";
import Box from "../../../../../ui/Box";
import SkillInfoDrawer from "../SkillInfoDrawer";
import ActionsMenu from "../../../../../ui/ActionsMenu";
import { getSkillAllAction } from "../../store/actions";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

class SkillTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedSkill: [],
      focusedSkill: 122,
      focusedRowIndex: -1
    };

    this.selectSkill = this.selectSkill.bind(this);
    this.addSKill = this.addSKill.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this.triggerColumnChooser = this.triggerColumnChooser.bind(this);
    this.exportSelectedSkill = this.exportSelectedSkill.bind(this);

    this.dataGridRef = React.createRef();
  }

  selectSkill({ selectedRowsData }) {
    this.setState({ selectedSkill: selectedRowsData });
  }

  addSKill () {
    console.log('add');
  }

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  triggerColumnChooser() {
    this.dataGridRef.current.instance.showColumnChooser()
  }

  exportSelectedSkill(selectionOnly) {
    this.dataGridRef.current.instance.exportToExcel(selectionOnly);
  }

  onRowClick = (e) => {
    const focusedSkill = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedSkill, focusedRowIndex });
  }

  render() {
    const {
      selectedSkill,
      focusedRowIndex,
      focusedSkill
      } = this.state;
    const {
      skillList,
      classes,
      getSkillAction
    } = this.props;
    const {root, skillContainer, controls } = classes;

    const skillActions = [
      {
        label: "Экспортировать выбранные",
        onClick: () => this.exportSelectedSkill(true)
      },
      {
        label: "Экспортировать все",
        onClick: () => this.exportSelectedSkill(false)
      },
      {
        label: "Выбор видимых столбцов",
        onClick: this.triggerColumnChooser
      }
    ];


    return (
      <div className={root}>
      <Box>
        <div className={controls}>
          <div>
            <SquareButton>
              <CachedIcon fontSize="small" onClick={getSkillAction} />
            </SquareButton>
            <SearchField width={400} onChange={this.searchByText} />
          </div>
          <div>
            <AddButton onClick={() => this.addSKill()} />
            <ActionsMenu actions={skillActions} />
          </div>
        </div>
        <div>
        <DataGrid
          elementAttr={{
            id: "gridContainer"
          }}
          ref={this.dataGridRef}
          wordWrapEnabled={true}
          dataSource={skillList}
          onSelectionChanged={this.selectSkill}
          focusedRowEnabled
          errorRowEnabled={false}
          onRowClick={this.onRowClick}
          focusedRowIndex={focusedRowIndex}
          showBorders
        >
          <Selection
          mode="multiple"
          showCheckBoxesMode="onClick"
          showBorders={true}
          width={120}
          />
           <StateStoring
                    enabled={true}
                    type={'localStorage'}
                    savingTimeout={0}
                    storageKey={'SkillTable'}/>
          {columns.map(column => (
            <Column key={column.dataField} {...column} />
          ))}
          <FilterRow visible={true} />
          <Scrolling mode="virtual" />
          <LoadPanel enabled/>
        </DataGrid>
        </div>
      </Box>
        <OutsideClickHandler onOutsideClick={() => this.onRowClick(-1)}>
          <SkillInfoDrawer
            handleDrawerClose={() => this.onRowClick(-1)}
            skillId={focusedSkill}
            open={focusedRowIndex !== -1}
          />
        </OutsideClickHandler>
      </div>
    );
  }
}

const mapStateToProps = state => ({ });

const mapDispatchToProps = dispatch => ({
  getSkillAction: () => dispatch(getSkillAllAction())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SkillTable));
